import React from 'react';
import { Route } from 'react-router';
import Received from './screens/Received/router';
import Sended from './screens/Sended/router';
export default (
  <Route
    path="assignmenttask"
    getComponent={(Location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
  {Received}
  {Sended}
  </Route>
);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/AssignmentTask/router.js
 **/